import { SWRConfiguration } from "swr";

import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { DealerProductDetailsRoute } from "../navigation/DealerRoutes";
import { useRouteParams } from "../navigation/useRouteParams";
import { PackagePartItem } from "./useSearchPartPackagesByVehicle";

export const useGetPartPackageByPartId = (
  swrOptions: SWRConfiguration<FetcherResult<PackagePartItem>> = {}
): ModifiedSWRResponse<FetcherResult<PackagePartItem>, PackagePartItem> => {
  const route = useRouteParams(DealerProductDetailsRoute);

  const { data, ...result } = useSwrGet<PackagePartItem>(
    route
      ? "/retailSiteWebService/parts/partPackage/getPartPackageByPartId.php"
      : null,
    route
      ? {
          dealerId: route.dealerId,
          partId: route.partId,
          vehicleId: route.vehicleId,
        }
      : {},
    swrOptions
  );

  return { ...result, data: Array.isArray(data) ? undefined : data };
};
